import { logWrapper } from '../utils';

function jointFlowDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    // Inicializa a lógica
    scope.init(element);

    // Carrega o fluxo e executa a função `load` com os dados obtidos
    scope.loadFlow()
      .then((data) => {
				scope.load(data);
      })
      .catch((error) => {
        // Trata erros de forma apropriada
        // eslint-disable-next-line no-console
        console.error('Erro ao carregar o fluxo:', error);
      });
  }

  function run() {
    return {
      restrict: 'A',
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const jointFlowDirective = ['runtimeConstant', jointFlowDirectiveFactory];
